import { render, staticRenderFns } from "./basePage.vue?vue&type=template&id=2c92b4f4&scoped=true"
import script from "./basePage.vue?vue&type=script&lang=js"
export * from "./basePage.vue?vue&type=script&lang=js"
import style0 from "./basePage.vue?vue&type=style&index=0&id=2c92b4f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c92b4f4",
  null
  
)

export default component.exports